import { Impression } from '../types';
import { Analytics } from '..';

export default function impression(self: Analytics) {
    return {
        dispatch(impression: Impression | Impression[]) {
            const products = Array.isArray(impression) ? impression : [impression];

            if (products.length <= 0) {
                return self;
            }

            self.dataLayer({
                ecommerce: {
                    impressions: products,
                },
                event: 'impressions',
            });

            return self;
        },
    };
}
